export const GROUP_NAME = 'toggle-group'
